import { Link } from 'react-router-dom';
import { IS_DEV } from 'src/constants';
import { resetCookieConsent } from 'src/utils/cookieConsent';
import { useModal } from '../context/ModalContext';
import { BrightSaaSLogo } from './BrightSaaSLogo';

export function BrightSaaSFooter() {
  const { open } = useModal();
  return (
    <footer className="nk-footer p-3">
      <div className="container">
        <div className="nk-footer-wrap card card-xl bg-background bg-opacity-50 border border-light border-opacity-50 rounded-7 has-mask overflow-hidden">
          <div className="bg-mask bg-glow-f" />
          <div className="card-body pb-0">
            <div className="nk-footer-cta pb-xl-15">
              <div className="row justify-content-center">
                <div className="col-xl-6">
                  <div className="text-block text-center">
                    <h2 className="title text-gradient-heading fw-normal fs-3 mb-5">
                      Ready to see what your data can tell you?
                    </h2>
                    <p className="lead">
                      Spin up your workspace, connect your channels, and run
                      your first model.
                    </p>
                    <ul className="nk-list-inline justify-content-center gap-6 mt-5 mt-lg-7">
                      <li>
                        <button
                          type="button"
                          onClick={() =>
                            open('contact', {
                              title: 'Get started',
                              submitText: 'Submit Application',
                            })
                          }
                          className="btn btn-primary btn-lg">
                          Get started
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="nk-footer-content pt-15 pb-10">
              <div className="row justify-content-between gy-6 g-4">
                <div className="col-xl-4 col-md-8 col-lg-6">
                  <BrightSaaSLogo className="mb-4" />
                  <p className="fs-8 mb-4 mb-md-7">
                    Marketing mix modelling — evidence, not gut feeling.
                  </p>
                </div>
                <div className="col-xl-7">
                  <div className="d-flex flex-wrap justify-content-end column-gap-5 row-gap-6">
                    <div className="col-md-3 col-6">
                      <div className="nk-footer-links">
                        <h6 className="title fs-9 mb-4">Company</h6>
                        <ul className="nk-list fs-9">
                          <li>
                            <Link
                              className="link link-content fw-normal link-hover-title"
                              to="/about">
                              About us
                            </Link>
                          </li>
                          <li>
                            <Link
                              className="link link-content fw-normal link-hover-title"
                              to="/careers">
                              Careers
                            </Link>
                          </li>
                          <li>
                            <Link
                              className="link link-content fw-normal link-hover-title"
                              to="/pricing">
                              Pricing
                            </Link>
                          </li>
                          <li>
                            <Link
                              className="link link-content fw-normal link-hover-title"
                              to="/integrations">
                              Integrations
                            </Link>
                          </li>
                          <li>
                            <a
                              className="link link-content fw-normal link-hover-title"
                              href="https://help.yapamar.com"
                              target="_blank"
                              rel="noopener noreferrer">
                              Help Center
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="col-md-3 col-6">
                      <div className="nk-footer-links">
                        <h6 className="title fs-9 mb-4">Legal</h6>
                        <ul className="nk-list fs-9">
                          <li>
                            <Link
                              className="link link-content fw-normal link-hover-title"
                              to="/terms">
                              Terms of Service
                            </Link>
                          </li>
                          <li>
                            <Link
                              className="link link-content fw-normal link-hover-title"
                              to="/privacy-policy">
                              Privacy Policy
                            </Link>
                          </li>
                          <li>
                            <Link
                              className="link link-content fw-normal link-hover-title"
                              to="/cookie-policy">
                              Cookies Policy
                            </Link>
                          </li>
                          <li>
                            <button
                              type="button"
                              className="link link-content fw-normal link-hover-title bg-transparent border-0 p-0"
                              onClick={resetCookieConsent}>
                              Cookie Settings
                            </button>
                          </li>
                          <li>
                            <Link
                              className="link link-content fw-normal link-hover-title"
                              to="/refund-policy">
                              Refund Policy
                            </Link>
                          </li>
                          {IS_DEV && (
                            <li>
                              <Link
                                className="link link-content fw-normal link-hover-title"
                                to="/service-description">
                                Service Description
                              </Link>
                            </li>
                          )}
                          {IS_DEV && (
                            <li>
                              <Link
                                className="link link-content fw-normal link-hover-title"
                                to="/subprocessors">
                                Subprocessors
                              </Link>
                            </li>
                          )}
                          {IS_DEV && (
                            <li>
                              <Link
                                className="link link-content fw-normal link-hover-title"
                                to="/dpa">
                                Data Processing Agreement
                              </Link>
                            </li>
                          )}
                          {IS_DEV && (
                            <li>
                              <Link
                                className="link link-content fw-normal link-hover-title"
                                to="/terms-of-exchange">
                                Terms of Exchange
                              </Link>
                            </li>
                          )}
                          {IS_DEV && (
                            <li>
                              <Link
                                className="link link-content fw-normal link-hover-title"
                                to="/saas-terms">
                                SaaS Terms
                              </Link>
                            </li>
                          )}
                          {IS_DEV && (
                            <li>
                              <Link
                                className="link link-content fw-normal link-hover-title"
                                to="/user-terms">
                                User Terms
                              </Link>
                            </li>
                          )}
                        </ul>
                      </div>
                    </div>
                    <div className="col-md-3 col-6">
                      <div className="nk-footer-links">
                        <h6 className="title fs-9 mb-4">Get in touch</h6>
                        <ul className="nk-list fs-9">
                          <li className="d-flex align-items-center gap-2">
                            <em className="icon ni ni-mail" />
                            <span>support@yapamar.com</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
